<template>
    <div class="">
        <YourCards />
        <div style="margin: 30px 20px;">
            <router-link to="/settings/payment-methods/add-new-card" class="btn btn-block">{{'pages/settings/payment-methods.index.title' | trans}}</router-link>
        </div>

    </div>
</template>

<script>
    import YourCards from '../../../components/Settings/YourCards';

    export default {
        name: "PaymentMethods",
        computed : {

        },
        components: {
            YourCards
        }
    }
</script>
